import styled from 'styled-components';

const yellowColor = '#f6a623';
const redColor = '#e61345';
const baseColor = '#ddd';

export const Container = styled.div`
  margin: 0 auto 30px;
  border-radius: 4px;
  border: 1px solid ${baseColor};
  font-size: 13px;

  color: ${props => (props.type === 'warning' ? yellowColor : redColor)};
`;

export const AlertHeader = styled.div`
  background-color: ${props => (props.type === 'warning' ? yellowColor : redColor)};
  color: ${props => (props.type ? '#fff' : '#333')};
  border-bottom: 1px solid ${baseColor};
  border-radius: 4px 4px 0 0;
  padding: 15px 15px 13px 15px;
  font-size: 15px;
  font-weight: bold;
`;

export const AlertContent = styled.div`
  border-radius: 0 0 4px 4px;
  padding: 30px;
  background: #fff;
`;
